export default "__VITE_ASSET__CF4Q0x6c__"